import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class ClaimDocumentationMappingsService {

    /*
    Language in the following format: en, es, fr...
     */
    getClaimFormForLanguage(language: string){
        switch (language){
            case 'es':
                return 'https://stgcosentprofesionalpro.blob.core.windows.net/we-app/documents/claim-form/claim-form-es.pdf';
            case 'en':
            default:
                return 'https://stgcosentprofesionalpro.blob.core.windows.net/we-app/documents/claim-form/claim-form-en.pdf';
        }
    }

}
